import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum"
const { monthClosingEntry } = stateEnum

const initialState = {
    detailParams: {},
    isNewEntry: false,
    mcsDetailParams: {},
    mcsIsNewEntry: true,
}


const monthlyClosingEntrySlice = createSlice({
    name: monthClosingEntry,
    initialState,
    reducers: {
        resetDetailParams: (state) => {
            state.detailParams = {}
            state.isNewEntry = true
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },
        mcsResetDetailParams: (state) => {
            state.mcsDetailParams = {}
            state.mcsIsNewEntry = true
        },
        setMcsDetailParams: (state, action) => {
            state.mcsDetailParams = action.payload
        },
        setMcsNewEntryMode: (state, action) => {
            state.mcsIsNewEntry = action.payload
        },

    },
})

export const { resetDetailParams, setNewEntryMode, setDetailParams, mcsResetDetailParams, setMcsDetailParams, setMcsNewEntryMode } =monthlyClosingEntrySlice.actions

export default monthlyClosingEntrySlice.reducer

